
import { Promise } from 'core-js'
import { DoubleSide, Vector3, Raycaster, Color, MeshStandardMaterial } from 'three'
// import { Color } from 'three'
import { loadFBX } from '../Loaders/loadFBX'
import { loadGLTF } from '../Loaders/loadGLTF'
// import { loadGLTF } from '../../../Core/loadGLTF'
// import { loadTexture } from '../../../Core/loadTexture'
// import { MatCapService } from '../../../Packages/MatCaps/MatCapService'
// import { MeshMatcapMaterial, DoubleSide, RepeatWrapping, Vector2 } from 'three'

class ClickableFloor {
  constructor ({ ctx, floor }) {
    let raycaster = new Raycaster()
    let tempPointer1 = new Vector3()
    let getFloorV3 = (coord, v3 = tempPointer1) => {
      raycaster.setFromCamera(coord, ctx.root.camera)
      let hit = raycaster.intersectObject(floor, false)
      // console.log(hit)
      let first = hit[0]
      if (first) {
        v3.x = first.point.x
        v3.y = first.point.y
        v3.z = first.point.z
        return v3
      } else {
        return false
      }
    }

    let isDown = false
    let moved = 0
    floor.userData.interactive = true
    floor.cursor = 'grab'
    floor.on('pointermove', () => {
      if (isDown) {
        moved++
        // console.log(moved)
      }
    })
    floor.on('pointerdown', () => {
      isDown = true
      ctx.root.controls.enabled = true
      floor.cursor = 'grabbing'
      moved = 0
    })

    floor.on('pointerup', (ev) => {
      isDown = false
      floor.cursor = 'grab'

      if (moved <= 10) {
        ctx.root.controls.enabled = true
        let position = getFloorV3(ev.data.global)
        ctx.root.events.emit('click-floor', { position: position })
        console.log(floor.name, position)
      }
      moved = 0
    })
  }
}


export class Cathedral {
  constructor ({ mount, ctx }) {
    this.ctx = ctx
    this.mount = mount
    // this.birthPlace = [126.0895767211914, 25, 364.65924072265625 + 220]
    // this.birthPlace = [0,50,0]
    // this.matcaps = MatCapService
    this.done = Promise.all([
      this.setup(),
      this.setupCross(),
      this.setupChair(),
      this.setupChair2()
    ])
  }
  async wait () {
    return this.done
  }
  async setupCross () {
    let objectURL = require('file-loader!./fbx/holy-cross.fbx')
    loadFBX(objectURL).then((stuff) => {
      stuff.traverse((item) => {
        if (item.isMesh) {
          item.material = this.ctx.root.chroma.out.material
        }
      })
      stuff.rotateX(Math.PI * 0.5)
      stuff.rotateY(Math.PI * -0.133333)
      stuff.scale.set(1.0, 1.0, 1.0)
      stuff.position.z = -1677.3623195000332
      stuff.position.y += 350
      this.ctx.scene.add(stuff)
    })
  }
  async setupChair () {
    let objectURL = require('file-loader!../Chairs/glb/modern-chair.glb')
    loadGLTF(objectURL).then((gltf) => {
      gltf.scene.traverse((item) => {
        if (item.isMesh) {
          item.material = this.ctx.root.chroma.out.material
        }
      })

      gltf.scene.position.y = 10
      gltf.scene.position.z = -100
      gltf.scene.scale.set(13.0 * 4.0, 13.0 * 4.0, 13.0 * 4.0)
      gltf.scene.rotateY(Math.PI * -1)
      let gap = 28
      let offsetX = 28
      for (let z = 0; z < 15; z++) {
        for (let x = -7; x < 7; x++) {
          if (x >= -1 && x <= 1) {
            continue
          }

          let chair = gltf.scene.clone()
          chair.position.x += x * gap + offsetX
          chair.position.z += z * gap
          this.ctx.scene.add(chair)

          // let geo = new BoxBufferGeometry(0.5, 0.5, 0.5)
          // let mat = new MeshBasicMaterial({ color: 0xffffff * Math.random() })
          // let simpleMesh = new Mesh(geo, mat)
          // simpleMesh.position.copy(chair.position)
          // simpleMesh.rotation.copy(chair.rotation)
          // simpleMesh.scale.copy(chair.scale)

          // this.ctx.ammo.addHullMesh({ mesh: simpleMesh, mass: 0.0, rootScale: 1.0 })
          // this.ctx.onLoop(() => {
          //   chair.position.copy(simpleMesh.position)
          //   chair.rotation.copy(simpleMesh.rotation)
          //   chair.scale.copy(simpleMesh.scale)
          // })
        }
      }
    })
  }
  async setupChair2 () {
    let objectURL = require('file-loader!../Chairs/glb/woord-chair-hand.glb')
    loadGLTF(objectURL).then((gltf) => {
      gltf.scene.traverse((item) => {
        if (item.isMesh) {
          item.material = this.ctx.root.chroma.out.material
        }
      })

      gltf.scene.position.y = 10
      gltf.scene.position.z = -100
      gltf.scene.scale.set(14.0, 14.0, 14.0)
      gltf.scene.rotateY(Math.PI * 0.5)
      let offsetY = -700
      let offsetX = 28 / 2
      for (let z = 0; z < 15; z++) {
        for (let x = -7; x < 7; x++) {
          if (x >= -1 && x <= 1) {
            continue
          }

          let chair = gltf.scene.clone()
          chair.position.x += x * 28 + offsetX
          chair.position.z += z * 28 + offsetY
          this.ctx.scene.add(chair)
        }
      }
    })
  }
  async setup () {
    let loaded = await loadFBX(require('file-loader!./fbx/geo-02.fbx'))
    // let marbelURL = require('./matcap/marbel.png')
    // let marbelLoader = new TextureLoader().load(marbelURL)
    // let marbelMat = new MeshMatcapMaterial({ matcap: marbelLoader })

    let rootScale = 0.6

    this.mount.add(loaded)
    // loaded.position.y = 0

    // this.mount.layers.set(1)

    // loaded.rotateY(Math.PI * 0.5)
    // loaded.position.y = -2

    // loaded.rotation.y = Math.PI * 0.5
    loaded.scale.set(rootScale, rootScale, rootScale)
    loaded.matrixAutoUpdate = false
    loaded.updateMatrix()
    // let stand = new Vector3()
    loaded.traverse((item) => {
      // item.rotateY(Math.PI * 0.5)
      if (item.isLight) {
        item.visible = false
      }

      if (item.isMesh) {
        item.material = new MeshStandardMaterial({ color: new Color('#444444') })
        item.receiveShadow = true
        // item.material = marbelMat

        if (item.name.indexOf('Cube') === 0) {
          if (this.ctx.chroma) {
            item.material = this.ctx.chroma.out.material
          }
        }

        item.material.side = DoubleSide

        if (item.name === 'floor-1') {
          item.visible = false
        }

        if (item.name === 'floor-2') {
          item.visible = false
        }

        if (item.name.indexOf('Cube012') === 0) {
          item.receiveShadow = true
          item.position.y -= 5
          // item.geometry.translate(0, -4, 0)
          // item.visible = true
          // item.material.color = new Color('#ffff00')
          if (this.ctx.root.ammo) {
            this.ctx.root.ammo.addHullMesh({ mesh: item, rootScale, mass: 0 })
            new ClickableFloor({ ctx: this.ctx, floor: item })
          }
          // item.getWorldPosition(stand)
        }
      }
    })


    // let plane = new BoxBufferGeometry(3000, 5000, 2, 2, 2, 2)
    // plane.rotateX(Math.PI * -0.5)
    // plane.translate(0, 0, -1500)
    // // let mat = new MeshBasicMaterial({ color: 0xff0000, transparent: true, opacity: 1 })
    // let meshFloor = new Mesh(plane, marbelMat)
    // addMesh({ mesh: meshFloor, rootScale: 1, mass: 0 })
    // this.mount.add(meshFloor)
  }
}
